import { NgModule } from '@angular/core';
import { NbButtonModule, NbCardModule, NbFormFieldModule, NbIconModule, NbInputModule, NbSpinnerModule, NbTooltipModule } from "@nebular/theme";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DatepickerComponent, DatepickerFilterComponent } from './datepicker/datepicker.component';
import { ThemeModule } from '../../@theme/theme.module';
import { CommonModule } from '@angular/common';
import { SmartTableButtonLinkRendererComponent } from './smart-table-button-link/smart-table-button-link.component';
import { RouterModule } from '@angular/router';
import { SmartTableExpirationsDatepickerComponent, SmartTableExpirationsDatepickerFilterComponent, SmartTableExpirationsDatepickerRenderComponent } from './smart-table-expirations-datepicker/smart-table-expirations-datepicker.component';
import { SmartTableButtonComponent } from './smart-table-button/smart-table-button.component';
import { NbSecurityModule } from '@nebular/security';
import { SmartTableFileOptionsComponent } from './smart-table-file-options/smart-table-file-options.component';
import { SmartTableHyperlinkComponent, SmartTableHyperlinkRenderComponent } from './smart-table-hyperlink/smart-table-hyperlink.component';
import { SmartTableDisableButtonComponent } from './smart-table-disable-button/smart-table-disable-button.component';
import { SmartTableStatusComponent, SmartTableStatusRenderComponent } from './smart-table-status/smart-table-status.component';
import { SmartTableBookButtonComponent } from './smart-table-book-button/smart-table-book-button.component';

@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    NbCardModule,
    NbButtonModule,
    NbIconModule,
    NbInputModule,
    FormsModule,
    ReactiveFormsModule,
    NbTooltipModule,
    RouterModule,
    NbSecurityModule,
    NbSpinnerModule,
  ],
  declarations: [
    DatepickerComponent,
    DatepickerFilterComponent,
    SmartTableButtonLinkRendererComponent,
    SmartTableExpirationsDatepickerFilterComponent,
    SmartTableExpirationsDatepickerRenderComponent,
    SmartTableExpirationsDatepickerComponent,
    SmartTableButtonComponent,
    SmartTableFileOptionsComponent,
    SmartTableHyperlinkComponent,
    SmartTableHyperlinkRenderComponent,
    SmartTableDisableButtonComponent,
    SmartTableStatusComponent,
    SmartTableStatusRenderComponent,
    SmartTableBookButtonComponent,
  ],
  exports: [
    DatepickerComponent,
    DatepickerFilterComponent,
    SmartTableExpirationsDatepickerFilterComponent,
    SmartTableExpirationsDatepickerRenderComponent,
    SmartTableExpirationsDatepickerComponent,
    SmartTableButtonComponent,
    SmartTableDisableButtonComponent, 
    SmartTableFileOptionsComponent,
    SmartTableHyperlinkComponent,
    SmartTableHyperlinkRenderComponent,
    SmartTableStatusComponent,
    SmartTableStatusRenderComponent,
    SmartTableBookButtonComponent,
  ],
})
export class SmartTableElementsModule { }
